<template>
  <div class="wrapper wrapper_main">
    <div class="wrapper-header">
      <TabsWidget activeTab="app_settings" @selected="switchTab"></TabsWidget>
    </div>
    <div class="wrapper-body">
      <b-tabs v-model="tabName" id="myTabs">
        <b-tab-item label="WEBSITE THEME" value="website_theme">
          <WebsiteTheme v-if="tabName == 'website_theme'" />
        </b-tab-item>
        <b-tab-item label="LANDING PAGE" value="landing_page">
          <landingPage v-if="tabName == 'landing_page'" />
        </b-tab-item>
        <b-tab-item label="BLOGS" value="blogs">
          <blogsVue v-if="tabName == 'blogs'" />
        </b-tab-item>
        <b-tab-item label="WEBSITE STATIC CONTENT" value="web_static">
          <websiteStatic v-if="tabName == 'web_static'" />
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>
  
<script>
import blogsVue from './components/blogs.vue';
import landingPage from './components/landing_page.vue';
import websiteStatic from './components/website_static.vue';
import WebsiteTheme from './components/website_theme.vue';
import TabsWidget from "./components/TabsWidget.vue"
export default {
  components: {
    blogsVue, landingPage, websiteStatic, WebsiteTheme, TabsWidget
  },
  data: () => ({
    currentPage: 'websiteTheme',
    tabName: 'website_theme'
  }),
  watch: {},
  mounted() {
    let vm = this;
  },
  computed: {},
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper_main {
  padding: 0px;
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;

  @media (max-width:650px) {
    flex-direction: column;
  }


  .wrapper-header {
    height: 100%;
    width: 250px;
    background: #fff;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ddd;
    padding: 10px 15px 0 6px;

    @media (max-width: 650px) {
      width: 100%;
      height: 70px;
      align-items: center;
      flex-direction: row;
      overflow-x: auto;
      column-gap: 10px;
    }

    .tab-item {
      cursor: pointer;
      padding: 14px 4px;
      border-left: 3px solid #fff;

      @media (max-width: 800px) {
        white-space: nowrap;
      }

      img {
        margin: 0 8px 0 10px;
        display: inline-flex;
      }

      &.active {
        color: var(--wecodefy-secondary-color, #9fc953);
        border-left: 3px solid var(--wecodefy-secondary-color, #9fc953);

        @media (max-width: 650px) {
          border-left: unset;
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }
  }

  .wrapper-body {
    width: calc(100% - 250px);
    display: flex;
    background: #fff;
    flex-direction: column;
    position: relative;

    @media (max-width: 650px) {
      width: 100%;
      height: calc(100% - 70px);
    }



    .b-tabs#myTabs {
      height: 100%;
      display: flex;
      flex-direction: column;

      .tab-content {
        padding: 0;
      }
    }
  }
}
</style>
  